<h2 class="sectionTitle">{{'SHARED.RequestHistory'| translate}}</h2>
<div class="request-summary" *ngIf="reqHistoryData?.RequestNumber != null && reqHistoryData?.ServiceName != null">
    <div class="request-summary-details">
        <label>{{ 'FRONT_USER.REQUEST_DETAILS.REQUEST_NUMBER' | translate }}: </label>
        <label>{{reqHistoryData?.RequestNumber}}</label>
    </div>
    <div class="request-summary-details">
        <label>{{ 'FRONT_USER.REQUEST_DETAILS.SERVICE_NAME' | translate }}: </label>
        <label>{{reqHistoryData?.ServiceName}}</label>
    </div>
    
</div>
<app-grid-view #RequestHistory></app-grid-view>